var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgU19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "11 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "11-copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    stroke: "#292929",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-38",
    transform: "translate(10.354391, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 1.5,
    y: 1.73223082,
    width: 36.2319738,
    height: 37.3448276,
    rx: 0.676808905
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6810948,1.73223082 L25.6810948,16.7759009 C25.6810948,16.9756722 25.5875945,17.163929 25.4284206,17.2846445 L25.4284206,17.2846445 L23.6444994,16.7240306 C22.791827,16.3672607 21.819165,16.4455794 21.034562,16.9341825 L21.034562,16.9341825 L19.611846,17.8201635 L18.2207103,16.9498389 C17.4132532,16.4446763 16.4069927,16.3756703 15.5381342,16.7658766 L15.5381342,16.7658766 L14.3910992,17.2810127 C14.2089467,17.3628178 13.9974946,17.3449747 13.8316263,17.2338022 C13.6487013,17.1111975 13.5389294,16.9054758 13.5389294,16.6852635 L13.5389294,16.6852635 L13.5389294,1.73223082 L25.6810948,1.73223082 Z",
    id: "\\u77E9\\u5F62",
    fill: "#2B6EFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-99",
    transform: "translate(0.000000, 26.294671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8965452,15.1672127 L39.9522143,15.1672127 C41.6733284,15.1672127 43.0806781,13.795171 43.1243994,12.0746123 C43.1689262,10.3223531 41.850007,8.83438601 40.1050688,8.66829677 C37.8298208,8.45172221 36.2122863,8.33580629 35.2524652,8.32054899 C31.981465,8.09776674 29.9029901,7.10162002 28.9731837,6.80721906 C22.0291227,4.58322378 14.1163044,5.52242239 9.46327279,15.8414867 C9.32714294,16.4301038 12.4384529,19.1147573 18.7972028,23.8954472 L37.7847392,23.8954472 C41.7628251,23.8954472 45.4918554,21.9587776 47.7798346,18.7045006 L57.8296037,4.4103441 C58.4953906,3.46337089 58.267444,2.15597051 57.3204708,1.49018362 C57.1398146,1.36316996 56.9402208,1.26550423 56.729075,1.20080039 C55.0534369,0.687315273 53.2330075,1.22165512 52.1007298,2.55933115 L41.9333118,14.5711464 L41.9333118,14.5711464",
    id: "\\u8DEF\\u5F84-195",
    fill: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88537269,18.9168509 L19.7816561,19.0600285 C20.8928308,19.0694445 21.791298,19.9679297 21.8006916,21.0791047 L21.8328929,24.8882122 C21.8424002,26.0128246 20.9384288,26.9322102 19.8138164,26.9417174 C19.8023267,26.9418146 19.7908364,26.9418145 19.7793467,26.9417171 L2.88306334,26.7985395 C1.77188858,26.7891235 0.873421425,25.8906383 0.864027804,24.7794633 L0.83182647,20.9703558 C0.822319251,19.8457434 1.72629061,18.9263578 2.850903,18.9168505 C2.86239269,18.9167534 2.873883,18.9167535 2.88537269,18.9168509 Z",
    id: "\\u77E9\\u5F62",
    fill: "#2B6EFF",
    transform: "translate(11.332360, 22.929284) rotate(41.000000) translate(-11.332360, -22.929284) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU19);
export default __webpack_public_path__ + "static/media/u19.102b3416357e9d3eb0487ffbf9a01b03.svg";
export { ForwardRef as ReactComponent };